'use strict';
const straight = function (connectorLayout) {
		return {
			'd': 'M' + Math.round(connectorLayout.from.x - connectorLayout.position.left) + ',' + Math.round(connectorLayout.from.y - connectorLayout.position.top) + 'L' + Math.round(connectorLayout.to.x - connectorLayout.position.left) + ',' + Math.round(connectorLayout.to.y - connectorLayout.position.top)
		};
	},
	roundedCoords = ({x, y}) => ({x: Math.round(x), y: Math.round(y)}),
	positionedLayout = (connectorLayout) => {
		return {
			from: roundedCoords({x: connectorLayout.from.x - connectorLayout.position.left, y: connectorLayout.from.y - connectorLayout.position.top}),
			to: roundedCoords({x: connectorLayout.to.x - connectorLayout.position.left, y: connectorLayout.to.y - connectorLayout.position.top})
		};
	};


module.exports = {
	'quadratic': function (connectorLayout, connectorTheme) {

		const limitVal = (limit, val) => {
				if (!val) {
					return val;
				}
				const sign = val < 0 ? -1 : 1;
				return Math.min(Math.abs(limit), Math.abs(val)) * sign;
			},
			start = {x: Math.round(connectorLayout.from.x - connectorLayout.position.left), y: Math.round(connectorLayout.from.y - connectorLayout.position.top)},
			end = {x: Math.round(connectorLayout.to.x - connectorLayout.position.left), y: Math.round(connectorLayout.to.y - connectorLayout.position.top)},
			dv = {x: end.x - start.x, y: end.y - start.y},
			requestedOffset = {x: dv.x * connectorTheme.controlPoint.width, y: dv.y * connectorTheme.controlPoint.height},
			maxOffset = {x: dv.x, y: Math.abs(dv.y) + connectorLayout.minHeight * 1.2},
			offset = {x: limitVal(maxOffset.x, requestedOffset.x), y: limitVal(maxOffset.y, requestedOffset.y)},
			controlPoint = {x: start.x + offset.x, y: start.y + offset.y},
			hasArrowsFrom = ['both', 'from'].includes(connectorLayout.connectorArrows),
			maxDvY = hasArrowsFrom ? 5 : 1;

		if (Math.abs(dv.y) < maxDvY) {
			return straight(connectorLayout);
		}
		return {
			'd': 'M' + start.x + ',' + start.y +
				'Q' + controlPoint.x + ',' + controlPoint.y + ' ' + end.x + ',' + end.y
		};
	},
	's-curve': function (connectorLayout) {
		const initialRadius = 10,
			dx = Math.round(connectorLayout.to.x - connectorLayout.from.x),
			dy = Math.round(connectorLayout.to.y - connectorLayout.from.y),
			dxIncrement = (initialRadius < Math.abs(dx * 0.5)) ? initialRadius * Math.sign(dx) : Math.round(dx * 0.5),
			dyIncrement = (initialRadius < Math.abs(dy * 0.5)) ? initialRadius * Math.sign(dy) : Math.round(dy * 0.5);

		return {
			'd': 'M' + (connectorLayout.from.x - connectorLayout.position.left) + ',' + (connectorLayout.from.y - connectorLayout.position.top) +
				'q' + dxIncrement + ',0 ' + dxIncrement + ',' + dyIncrement +
				'c0,' + (dy - (2 * dyIncrement)) + ' ' + Math.round(dx / 2  - dxIncrement) + ',' +  (dy - dyIncrement) + ' '  + (dx - dxIncrement) + ',' + (dy - dyIncrement)
		};

	},
	'top-down-s-curve': function (connectorLayout, connectorTheme) {

		const dx = Math.round(connectorLayout.to.x - connectorLayout.from.x),
			dy = Math.round(connectorLayout.to.y - connectorLayout.from.y),
			spaceRequired = 15,
			dxIncrement = spaceRequired * Math.sign(dx),
			dyIncrement = spaceRequired * Math.sign(dy),
			appendixLength = Math.sign(dy),
			appendix = appendixLength ? 'v' + appendixLength : '',
			halfHeight = Math.round(0.5 * dy),
			halfHeightSign = Math.sign(halfHeight),
			halfHeightMagnitude = Math.abs(halfHeight),
			beforeEnd = halfHeightSign * Math.min(halfHeightMagnitude, connectorTheme?.controlPoint?.beforeEnd || halfHeightMagnitude),
			verticalLine = dy - beforeEnd - dyIncrement,
			flatLine = function () {
				const yIncrement = verticalLine + Math.round(0.5 * dyIncrement);
				return {
					'd': 'M' + (connectorLayout.from.x - connectorLayout.position.left) + ',' + (connectorLayout.from.y - connectorLayout.position.top) +
						'v' + yIncrement +
						'l' + dx + ',' + (dy - yIncrement - appendixLength) + appendix,
					'initialRadius': 5
				};
			};
		if (spaceRequired > Math.abs(dx / 2)) {
			return flatLine();
		}
		return {
			'd': 'M' + (connectorLayout.from.x - connectorLayout.position.left) + ',' + (connectorLayout.from.y - connectorLayout.position.top) +
				'v' + verticalLine +
				'q0,' + dyIncrement + ' ' + dxIncrement + ',' + dyIncrement +
				'h' + (dx - (2 * dxIncrement)) +
				'q' + dxIncrement + ',0 ' + dxIncrement + ',' +  dyIncrement +
				'v' + (beforeEnd - dyIncrement),
			'initialRadius': 5
		};

	},
	'compact-s-curve': function (connectorLayout) {
		const initialRadius = 10,
			dx = Math.round(connectorLayout.to.x - connectorLayout.from.x),
			dy = Math.round(connectorLayout.to.y - connectorLayout.from.y),
			dxIncrement = initialRadius * Math.sign(dx),
			dyIncrement = initialRadius * Math.sign(dy),
			flatLine = function () {
				const xIncrement = Math.round(dx / 2);
				return {
					'd': 'M' + (connectorLayout.from.x - connectorLayout.position.left) + ',' + (connectorLayout.from.y - connectorLayout.position.top) +
						'l' + xIncrement + ',0 ' +
						'l' + (dx - xIncrement - Math.sign(dx)) + ',' + dy +
						'h' + Math.sign(dx)
				};
			},
			appendixLength = (dx - (2 * dxIncrement)),
			appendix = appendixLength ? 'h' + appendixLength : '';

		if (initialRadius > Math.abs(dx * 0.5) || initialRadius > Math.abs(dy * 0.5)) {
			return flatLine();
		}
		return {
			'd': 'M' + (connectorLayout.from.x - connectorLayout.position.left) + ',' + (connectorLayout.from.y - connectorLayout.position.top) +
				'q' + dxIncrement + ',0 ' + dxIncrement + ',' + dyIncrement +
				'v' + (dy - (2 * dyIncrement)) +
				'q0,' + dyIncrement + ' ' + dxIncrement + ',' +  dyIncrement +
				appendix
		};

	},
	'vertical-quadratic-s-curve': function (connectorLayout, connectorTheme) {
		const dx = Math.round(connectorLayout.to.x - connectorLayout.from.x),
			dy = Math.round(connectorLayout.to.y - connectorLayout.from.y),
			dxIncrement = dx / 2,
			dyIncrement = dy / 2,
			initialRadius = (connectorTheme && connectorTheme.line && connectorTheme.line.initialRadius) || 10,
			cornerRadius = (connectorTheme && connectorTheme.line && connectorTheme.line.cornerRadius);

		if (Math.abs(dx) < 20) {

			return {
				'd': 'M' + (connectorLayout.from.x - connectorLayout.position.left) + ',' + (connectorLayout.from.y - connectorLayout.position.top) +
					'l' + dx + ',' + dy,
				initialRadius,
				cornerRadius
			};
		}
		return {
			'd': 'M' + (connectorLayout.from.x - connectorLayout.position.left) + ',' + (connectorLayout.from.y - connectorLayout.position.top) +
				'q0,' + Math.round(dyIncrement / 2) + ' ' + dxIncrement + ',' + dyIncrement +
				'q' + dxIncrement + ',' + Math.round(dyIncrement / 2) + ' ' + dxIncrement + ',' +  dyIncrement,
			initialRadius,
			cornerRadius
		};
	},
	'vertical-s-curve': function (connectorLayout) {
		const initialRadius = 10,
			dx = Math.round(connectorLayout.to.x - connectorLayout.from.x),
			dy = Math.round(connectorLayout.to.y - connectorLayout.from.y),
			dxIncrement = initialRadius * Math.sign(dx),
			dyIncrement = initialRadius * Math.sign(dy);

		if (initialRadius > Math.abs(dx * 0.5) || initialRadius > Math.abs(dy * 0.5)) {
			return {
				'd': 'M' + (connectorLayout.from.x - connectorLayout.position.left) + ',' + (connectorLayout.from.y - connectorLayout.position.top) +
					'l' + dx + ',' + dy
			};
		}
		return {
			'd': 'M' + (connectorLayout.from.x - connectorLayout.position.left) + ',' + (connectorLayout.from.y - connectorLayout.position.top) +
				'q0,' + dyIncrement + ' ' + dxIncrement + ',' + dyIncrement +
				'h' + (dx - (2 * dxIncrement)) +
				'q' + dxIncrement + ',0 ' + dxIncrement + ',' +  dyIncrement +
				'v' + (dy - (2 * dyIncrement))
		};

	},
	'straight': straight,
	'straight-s': function (connectorLayout) {
		const dxSign = Math.sign(connectorLayout.to.x - connectorLayout.from.x);
		return {
			'd': 'M' + Math.round(connectorLayout.from.x - connectorLayout.position.left) + ',' + Math.round(connectorLayout.from.y - connectorLayout.position.top)
				+ 'h' + dxSign
				+ 'L' + Math.round(connectorLayout.to.x - connectorLayout.position.left - dxSign) + ',' + Math.round(connectorLayout.to.y - connectorLayout.position.top)
			+ 'h' + dxSign
		};
	},
	'straight-s-to': function (connectorLayout) {
		const dxSign = Math.sign(connectorLayout.to.x - connectorLayout.from.x);
		return {
			'd': 'M' + Math.round(connectorLayout.from.x - connectorLayout.position.left) + ',' + Math.round(connectorLayout.from.y - connectorLayout.position.top)
				+ 'L' + Math.round(connectorLayout.to.x - connectorLayout.position.left - dxSign) + ',' + Math.round(connectorLayout.to.y - connectorLayout.position.top)
			+ 'h' + dxSign
		};
	},
	'brolly-handle': (connectorLayout, connectorTheme) => {
		const dy = Math.round(connectorLayout.to.y - connectorLayout.from.y),
			preferredInset = connectorTheme?.line?.initialRadius || 0,
			inset = Math.min(preferredInset, Math.abs(dy)),
			dyIncrement = inset * Math.sign(dy);
		return {
			'd': 'M' + Math.round(connectorLayout.from.x - connectorLayout.position.left) + ',' + Math.round(connectorLayout.from.y - connectorLayout.position.top)
			+ 'v' + (connectorLayout.to.y - connectorLayout.from.y - dyIncrement)
			+ 'q' + '0,' + dyIncrement + ' ' + (connectorLayout.to.x - connectorLayout.from.x) + ',' + dyIncrement
		};
	},
	'no-connector': function (connectorLayout) {
		return {
			'd': 'M' + Math.round(connectorLayout.to.x - connectorLayout.position.left) + ',' + Math.round(connectorLayout.to.y - connectorLayout.position.top)
		};
	},
	'fishbone-c': (connectorLayout, connectorTheme) => {
		const positioned = positionedLayout(connectorLayout),
			p1 = positioned.from,
			p3 = positioned.to,
			dy = p3.y - p1.y,
			angleDegrees = Number.isFinite(connectorTheme.angleDegrees)? connectorTheme.angleDegrees : -30,
			piRads = angleDegrees / 180,
			dx = Math.tan(Math.PI * piRads * Math.sign(dy)) * (dy),
			p2 = roundedCoords({x: p1.x + dx, y: p3.y}),
			coords = `M${p3.x},${p3.y}L${p2.x},${p2.y}`;
		if (Math.abs(angleDegrees % 180) === 90) {
			return straight(connectorLayout, connectorTheme);
		}
		return {
			'd': coords
		};
	},
	'fishbone-s': (connectorLayout, connectorTheme) => {
		const positioned = positionedLayout(connectorLayout),
			p1 = positioned.from,
			p3 = positioned.to,
			dy = p3.y - p1.y,
			angleDegrees = Number.isFinite(connectorTheme.angleDegrees)? connectorTheme.angleDegrees : -30,
			piRads = angleDegrees / 180,
			dx = Math.tan(Math.PI * piRads * Math.sign(dy) * -1 ) * (dy),
			p2 = roundedCoords({x: p3.x - dx, y: p1.y}),
			coords = `M${p1.x},${p1.y}L${p2.x},${p2.y}L${p3.x},${p3.y}`;
		if (Math.abs(angleDegrees % 180) === 90) {
			return straight(connectorLayout, connectorTheme);
		}
		return {
			'd': coords
		};
	}

};
